enum VideoQuality {
  // Use best possible
  Best = "Best",
  // At least as wide as video player width
  X1 = "X1",
  // At least as wide as 2x video player width
  X2 = "X2",
}

export default VideoQuality;
